import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceDrawerChangedEvent } from '@platform/event-bus/domain/events/service-drawer.event';
import { ServiceRedirectPort } from '@features/service/domain/port/service-redirect.port';

@Injectable({ providedIn: 'root' })
export class ServiceChangeDrawerSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly redirect = inject(ServiceRedirectPort);

  constructor() {
    this.eventBus
      .ofType(ServiceDrawerChangedEvent)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => this.redirect.goToServiceConfiguration())
      )
      .subscribe();
  }
}